import { type ReactNode, useState } from 'react';
import type { QuickMenuOptions } from '.';
import { QuickMenuContext } from './QuickMenuContext';

interface QuickMenuProviderProps {
  children: ReactNode;
}

export const QuickMenuProvider = ({ children }: QuickMenuProviderProps) => {
  const [quickMenu, setQuickMenu] = useState<QuickMenuOptions | undefined>();

  return (
    <QuickMenuContext.Provider value={{ quickMenu, setQuickMenu }}>
      {children}
    </QuickMenuContext.Provider>
  );
};
